module.exports = __webpack_public_path__ + "static/media/IconTemplates_-93.248b9621.svg";